import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    icon: '🎁',
    name: 'Recetario H.E.R. (63 recetas antiinflamatorias)',
    description: 'Comidas simples para 21 días: menos hinchazón, más energía y menos antojos.',
    value: '$8,999 ars',
    image: 'https://cdn.magicpatterns.com/uploads/bmbfUCYvfUbNEnZTry2tzw/Dbwg90-6Hw-fZC0GrtI0R.png',
    details: ['21 desayunos + 21 almuerzos + 21 cenas.', 'Ingredientes accesibles + pasos claros.', 'Sustituciones para Argentina.', 'Ideal por fases (H/E/R).', 'Rotación para no aburrirte.']
  }, {
    icon: '🎁',
    name: 'H.E.R. Movement (21 rutinas progresivas en casa)',
    description: 'Activás tu metabolismo sin agotarte ni ir al gimnasio.',
    value: '$5,499 ars',
    image: 'https://cdn.magicpatterns.com/uploads/2BYTqkeEEengQWMHg7GS27/S8SNVUZHdzf8t092yIlAK.png',
    details: ['15–25 min por día.', 'Sin equipo.', 'Adaptado a tu energía.', '21 rutinas progresivas (1 por día).', 'Fuerza + tono + movilidad (por semanas).']
  }, {
    icon: '🎁',
    name: 'Guía de Compras Argentina + Meal Prep (21 días)',
    description: 'Sabés qué comprar y cómo organizarte sin pensar.',
    value: '$12,999 ars',
    image: 'https://cdn.magicpatterns.com/uploads/3FaeJLwJsaCjczFx2huS9A/1I1NNttJTHz_ql3yYujuX.png',
    details: ['Lista de compras lista para usar.', 'Menos decisiones, más constancia.', 'Comés simple sin improvisar.', 'Versión "Económica Argentina" (sustituciones simples y accesibles).', 'Meal prep en 2 horas (qué cocinar primero y cómo combinar bases 3–4 días).', 'Checklist imprimible + lista "infaltables" (alacena/freezer).', '✨ Ideal si querés sostener el protocolo sin improvisar ni gastar de más.']
  }, {
    icon: '🎁',
    name: 'Tracker H.E.R. (21 días) — imprimible + digital',
    description: 'Seguimiento simple para sostener constancia sin obsesión.',
    value: '$6,999 ars',
    image: 'https://cdn.magicpatterns.com/uploads/feaGqTys9EShHB6o8riQS1/v5gVLGm07qY3WP7hCr5Mp.png',
    details: ['Checklist diario (Día 1–21): agua, proteína, vegetales, movimiento y sueño.', 'Escalas rápidas 1–5: energía, hinchazón, antojos, ánimo y estrés.', 'Notas opcionales: digestión, ciclo, retención y disparadores.', 'Mediciones/fotos opcionales: Día 1 / 7 / 14 / 21.', 'Cierre del día 21: qué funcionó + ajustes + plan de continuidad.', 'Formato: PDF imprimible + versión digital (Google Sheets / Notion / PDF rellenable).']
  }, {
    icon: '🎁',
    name: 'Noche en Calma',
    subtitle: 'Anti-antojo nocturno + sueño más profundo (7 noches)',
    description: 'Cortás el ciclo de estrés, antojos y mal descanso con una rutina simple para cerrar el día en calma.',
    value: '$9,999 ars',
    image: 'https://cdn.magicpatterns.com/uploads/uUXGwc4V4JvvPjBNcTav62/-qushb3WzLl3BYpA9n1eL.png',
    details: ['Protocolo de 7 noches (paso a paso).', 'Rutina nocturna 10–15 min (respiración + estiramientos + descarga mental).', 'Cenas livianas y saciantes (combinaciones rápidas).', 'Qué hacer a las 22:00 cuando aparece el antojo (opciones de reemplazo).', 'Kit anti-antojo: infusiones + snacks reales para no improvisar.', '✨ Ideal si tu mayor desafío es la noche.']
  }];
  return <section className="bg-gradient-section py-8 md:py-10 px-4 md:px-8" data-id="element-35">
      <div className="max-w-[1400px] mx-auto space-y-8" data-id="element-36">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4 max-w-3xl mx-auto" data-id="element-37">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-black leading-tight" data-id="element-38">
            PERO ESO NO ES TODO...{' '}
            <span className="text-gradient-gold" data-id="element-39">
              HOY TAMBIÉN RECIBES 5 BONOS EXCLUSIVOS:
            </span>
          </h2>
          <p className="text-lg md:text-xl text-foreground/70 font-body italic" data-id="element-40">
            Para que no tengas que pensar ni improvisar nada:
          </p>
          <p className="text-2xl md:text-3xl font-display font-bold text-secondary" data-id="element-41">
            VALOR: $44.000 ars
          </p>
        </motion.div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-42">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`bg-card border border-border rounded-xl p-5 md:p-6 flex flex-col items-center gap-4 hover:border-gold/30 transition-colors duration-300 group ${i === 0 ? 'lg:col-span-2' : ''}`} data-id="element-43">
              {/* Emoji + Number */}
              <span className="text-2xl font-display font-bold text-foreground" data-id="element-44">
                {bonus.icon} #{i + 1}
              </span>

              {/* Large centered image */}
              <div className="w-56 h-72 md:w-72 md:h-96 rounded-xl overflow-hidden shadow-gold border border-gold/20" data-id="element-45">
                <img src={bonus.image} alt={bonus.name} className="w-full h-full object-cover" data-id="element-46" />
              </div>

              {/* Name */}
              <h3 className="text-lg font-display font-bold text-foreground text-center leading-snug" data-id="element-47">
                {bonus.name}
              </h3>
              {'subtitle' in bonus && bonus.subtitle && <p className="text-sm text-foreground/70 font-body font-medium text-center -mt-2 leading-relaxed" data-id="element-48">
                  {bonus.subtitle}
                </p>}

              {/* Description */}
              {bonus.description && <p className="text-foreground/80 font-body text-[15px] md:text-base font-medium leading-relaxed text-center max-w-xs italic" data-id="element-49">
                  "{bonus.description}"
                </p>}

              {/* Accordion Details */}
              {'details' in bonus && bonus.details && <details className="w-full max-w-sm" data-id="element-50">
                  <summary className="cursor-pointer text-secondary font-display font-semibold text-base text-center list-none flex items-center justify-center gap-2 hover:text-secondary/80 transition-colors" data-id="element-51">
                    <span data-id="element-52">📋 Incluye:</span>
                    <svg className="w-4 h-4 transition-transform details-open:rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-53">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-54" />
                    </svg>
                  </summary>
                  <ul className="mt-3 space-y-3 text-left" data-id="element-55">
                    {bonus.details.slice(0, 3).map((detail: string, j: number) => <li key={j} className="flex items-start gap-2 text-foreground/80 font-body text-sm font-medium leading-relaxed" data-id="element-56">
                          <span className="text-secondary mt-0.5 flex-shrink-0" data-id="element-57">
                            ✓
                          </span>
                          <span data-id="element-58">{detail}</span>
                        </li>)}
                  </ul>
                </details>}

              {/* Value */}
              <div className="text-center mt-2" data-id="element-59">
                <p className="text-secondary font-bold font-display text-lg" data-id="element-60">
                  Bono sin costo
                </p>
                <p className="text-foreground/50 font-body text-[10px] uppercase tracking-wider font-bold mt-1" data-id="element-61">
                  (por tiempo limitado)
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing emotional text */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-2xl mx-auto mt-12 space-y-3" data-id="element-62">
          <p className="text-xl md:text-2xl font-display font-bold text-gradient-gold leading-snug" data-id="element-63">
            Podés seguir haciendo lo mismo…
          </p>
          <p className="text-base md:text-lg font-body font-medium leading-relaxed" style={{
          color: 'rgba(255, 255, 255, 0.85)'
        }} data-id="element-64">
            Podés seguir probando dietas que ya no funcionan para tu cuerpo… o
            podés empezar a entender lo que está pasando y aplicar una
            estrategia distinta.
          </p>
        </motion.div>
      </div>
    </section>;
}